import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LaptopChromebookIcon(props: IconProps) {
    return <Icon {...props} iconKey={"laptop_chromebook"}/>
}
